import { getInitials } from "@/lib/interview-ui";
import { Star } from "lucide-react";

interface CandidateRowAvatarProps {
  name: string;
  rank?: number | undefined;
}

export function CandidateRowAvatar({ name, rank }: CandidateRowAvatarProps) {
  return (
    <div className="relative shrink-0" data-testid="candidate-row-avatar">
      <div
        aria-label={name}
        className="w-9 h-9 rounded-full bg-teal-50 flex items-center justify-center text-teal-700 font-bold text-xs ring-1 ring-teal-100 shadow-sm"
      >
        {getInitials(name)}
      </div>
      {rank !== undefined && (
        <div
          className="absolute -bottom-1 -right-1 bg-white rounded-full p-0.5"
          data-testid="candidate-row-avatar-rank"
        >
          <div className="bg-teal-600 text-white text-[8px] font-bold px-1 py-0.5 rounded-full inline-flex items-center gap-0.5 shadow-sm">
            <Star className="size-2 fill-current" />
            {rank}位
          </div>
        </div>
      )}
    </div>
  );
}
